/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Page_TitleInputs */

const fr_help_page_title = /** @type {(inputs: Help_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aide & FAQ – Bus Tracker`)
};

const en_help_page_title = /** @type {(inputs: Help_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help & FAQ – Bus Tracker`)
};

/**
* | output |
* | --- |
* | "Help & FAQ – Bus Tracker" |
*
* @param {Help_Page_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_page_title = /** @type {((inputs?: Help_Page_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Page_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_page_title(inputs)
	return en_help_page_title(inputs)
});